export const siteConfig = {
  brandName: "RP Abu Dhabi GP",
  eventName: "Abu Dhabi Race Weekend 2026",
  publicEventWindow: "3–6 December 2026",
  competitiveWeekend: "4–6 December 2026",
  countdownTarget: "2026-12-03T00:00:00+04:00",
  venue: "Yas Marina Circuit, Abu Dhabi",
  supportEmail: "info@royalpath.ae",
  supportPhone: "To be confirmed",
  whatsappUrl: "https://wa.me/971503494666",
  companyName: "ROYAL PATH",
  ticketStatusDisclosure:
    "Royal Path is an independent booking agent for resale tickets, not the primary provider.",
  ticketPriceDisclosure:
    "Prices may exceed face value.",
  quoteDisclosure:
    "Listed prices are indicative, not a final payable total. Royal Path will provide a written itemised quote showing the ticket or package price, applicable taxes, booking or service fees, and the total payable amount for you to review before agreeing to a booking and before Royal Path accepts any payment. No payment is collected on this website.",
  currency: "AED" as const,
  socialLinks: {
    instagram: "",
    x: "",
    facebook: "",
  },
  businessDisclosure:
    "Royal Path operates RP Abu Dhabi GP as an independent booking agent arranging third-party ticket resale for race-weekend reservations, not as the primary ticket provider. Ticket prices may be higher than face value (the original price set by the primary ticket provider). We are not the official Formula 1, FIA, Yas Marina Circuit, Ethara, Ticketmaster, or Abu Dhabi Grand Prix website and do not claim affiliation with those organisations. Ticket availability, pricing, seating, access conditions, and fulfilment remain subject to confirmation from the relevant authorised ticket supplier or event organiser.",
  legalDisclaimer:
    "RP Abu Dhabi GP is operated by Royal Path, an independent booking agent for ticket resale, and is not the official event organiser or ticketing platform. All trademarks belong to their respective owners.",
} as const;
